import api from '../utils/api';
import { ICreateMeal } from '../interfaces/meal';
import { IUserStorage } from '../hooks/auth';

const userData = JSON.parse(
  <string>localStorage.getItem('userData'),
) as IUserStorage;

const get = async (limit: number) => {
  return api
    .get(`/tracker/meal?limit=${limit}`, {
      headers: {
        Authorization: `Bearer ${userData.accessToken}`,
      },
    })
    .then((response) => response.data.data);
};

const getGroup = async (trackId: string, groupId: string) => {
  return api
    .get(`/tracker/${trackId}/group/${groupId}`, {
      headers: {
        Authorization: `Bearer ${userData.accessToken}`,
      },
    })
    .then((response) => response.data.data);
};

const searchFood = async (pattern: string) => {
  return api
    .get(`/tracker/food?search=${pattern}`, {
      headers: {
        Authorization: `Bearer ${userData.accessToken}`,
      },
    })
    .then((response) => response.data.data);
};

const finishDay = async () => {
  return api
    .post(
      `/tracker/finish`,
      {},
      {
        headers: {
          Authorization: `Bearer ${userData.accessToken}`,
        },
      },
    )
    .then((response) => response.data.data);
};

const saveMeals = async (dto: ICreateMeal) => {
  return api
    .post(`/tracker/meal`, dto, {
      headers: {
        Authorization: `Bearer ${userData.accessToken}`,
      },
    })
    .then((response) => response.data.data);
};

const removeMeal = async (trackId: string, mealId: string) => {
  return api
    .delete(`/tracker/${trackId}/meal/${mealId}`, {
      headers: {
        Authorization: `Bearer ${userData.accessToken}`,
      },
    })
    .then((response) => response.data.data);
};

const addMeal = async (id: string, mealGroupName: string) => {
  return api
    .post(
      `/tracker/group`,
      {
        id: id,
        name: mealGroupName,
      },
      {
        headers: {
          Authorization: `Bearer ${userData.accessToken}`,
        },
      },
    )
    .then((response) => response.data.data);
};

export const tracker = {
  get,
  addMeal,
  finishDay,
  getGroup,
  searchFood,
  saveMeals,
  removeMeal,
};
